import { MaterialCreationProcess, MaterialProductInfoListItem } from '../../schemas';
import { getInternalFullMaterialProductComponentListLabel } from '../materialComponentValue/materialComponentValue';

export const getCreationProcessDisplayedName = (creationProcess: MaterialCreationProcess): string => {
  switch (creationProcess) {
    case MaterialCreationProcess.HAND_PICKED:
      return 'Hand Picked';
    case MaterialCreationProcess.MECHANICAL:
      return 'Mechanical';
    default:
      return 'Unknown';
  }
};

export const getFoodGradeDisplayedName = (isFoodGrade: boolean): string => {
  return isFoodGrade ? 'Food Grade' : 'Non Food Grade';
};

export const getCapsAndLabelsDisplayedName = (hasCapsAndLabels: boolean): string => {
  return hasCapsAndLabels ? 'w Caps and Labels' : 'w/o have Caps and Labels';
};

const capitalizeString = (str: string) =>
  str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const getInternalMaterialProductName = (materialProduct: MaterialProductInfoListItem): string => {
  // This is not a complete implementation, but it should be enough to demonstrate the concept.
  // We will have different implementations based on the view( internal/external).
  let materialProductName =
    materialProduct.material_spec.title + ' - ' + materialProduct.material_grade.name + ' - ' + materialProduct.country;
  if (materialProduct.material_origin) {
    materialProductName += ' - ' + capitalizeString(materialProduct.material_origin.type);
  }
  if (materialProduct.creation_process) {
    materialProductName += ' - ' + getCreationProcessDisplayedName(materialProduct.creation_process);
  }
  if (materialProduct.is_food_grade !== null) {
    materialProductName += ' - ' + getFoodGradeDisplayedName(materialProduct.is_food_grade);
  }
  if (materialProduct.has_caps_and_labels !== null) {
    materialProductName += ' - ' + getCapsAndLabelsDisplayedName(materialProduct.has_caps_and_labels);
  }
  if (materialProduct.material_component_values) {
    materialProductName +=
      ' - ' + getInternalFullMaterialProductComponentListLabel(materialProduct.material_component_values);
  }
  return materialProductName;
};
